import { SeoPage, SeoReplaceValues } from 'libs/shared-lib/interfaces';
export const LOCATIONS_SEO_FR: SeoPage = {
    title: `${SeoReplaceValues.DEALER_NAME}: Nos sites compétents`,
    description: '',
    image: '',
    twitter: {
        card: 'summary',
        title: `${SeoReplaceValues.DEALER_NAME}: Nos sites compétents`,
        description: '',
    },
    og: {
        title: `${SeoReplaceValues.DEALER_NAME}: Nos sites compétents`,
        description: '',
    },
    robots: {
        noIndex: false,
        noFollow: false,
    },
};
